import gql from "graphql-tag";

export default gql`
  mutation updateSource($sourceInput: SourceInputInput, $customerId: ID, $sourceId: ID) {
    updateSource(sourceInput: $sourceInput, customerId: $customerId, sourceId: $sourceId) {
      id
      deploymentId
    }
  }
`;
